/**
 * 正则相关
 */
const rules = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  password: /^(?![\d]+$)(?![a-zA-Z]+$)(?![@$!%*#_~?&^]+$)[\da-zA-Z@$!%*#_~?&^]{8,50}$/,
  name: /^[\u4e00-\u9fa5a-zA-Z1-9]{1,50}$/,
};

export default rules;
